import React from 'react';
import {
  ImageBackground,
  ScrollView,
  TouchableOpacity,
  View
} from 'react-native';
import {LinearGradient} from 'expo-linear-gradient';
import backgroundImage from '../../../../assets/background.png';
import {colors} from '../../../style/rulesEngine';
import {touchTargetMin} from '../../../style/adminTools';
import {
  PANEL_GRADIENT_COLORS,
  PANEL_GRADIENT_LOCATIONS
} from '../AdminPlaceholderScreen';

const AdminPanelShell = ({onOpenMenu, children, scrollStyle}) => {
  return (
    <ImageBackground style={{flex: 1}} source={backgroundImage}>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          height: 56,
          paddingHorizontal: 16
        }}
      >
        <TouchableOpacity
          testID="adminPlaceholderMenuButton"
          accessibilityLabel="Open menu"
          onPress={onOpenMenu}
          style={{
            width: touchTargetMin,
            height: touchTargetMin,
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <i className="icon-menu" style={{color: colors.text, fontSize: 24}} />
        </TouchableOpacity>
      </View>
      <ScrollView
        testID="adminPanelScroll"
        style={scrollStyle}
        contentContainerStyle={{
          paddingHorizontal: 16,
          paddingTop: 32,
          paddingBottom: 32
        }}
      >
        <LinearGradient
          colors={PANEL_GRADIENT_COLORS}
          locations={PANEL_GRADIENT_LOCATIONS}
          start={{x: 0, y: 0}}
          end={{x: 1, y: 1}}
          style={{
            width: '100%',
            borderRadius: 20,
            padding: 24,
            boxShadow: '0px 0px 10px 0px rgba(255, 255, 255, 0.2)'
          }}
        >
          {children}
        </LinearGradient>
      </ScrollView>
    </ImageBackground>
  );
};

export default AdminPanelShell;
